exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-tab[data-v-07d68cb4] {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);\n  border: 0;\n  padding: 8px 30px;\n  color: #085FCE;\n  font-size: 14px;\n}\n.sub-tab.small[data-v-07d68cb4] {\n  padding: 8px 16px;\n  height: 40px;\n}\n.sub-tab.active[data-v-07d68cb4] {\n  color: white;\n  background-color: #085FCE;\n}\n.sub-tab[data-v-07d68cb4]:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);\n}\n.sub-tab-group.vertical .sub-tab[data-v-07d68cb4] {\n  text-align: right;\n}", ""]);

// exports
